module.exports = {
    roles: {
        exception: ['uma_authorization', 'offline_access'],
        eod: ['root'],
        contacts: ['contributor', 'responsible'],
        collaborators: ['member', 'admin', 'lead'],
        connectors: ['connector'],
        responsibles: ['responsible'],
        anonymous: ['informant']
    },
    getRoleGroupName(roleName) {
        for (const groupName in this.roles) {
            const roles = this.roles[groupName];
            if (roles.includes(roleName)) {
                return groupName;
            }
        }
        return null;
    },
    // Rolhiërarchie van hoog naar laag: een gebruiker ziet enkel gebruikers met dezelfde of een lagere rol.
    roleHierarchy: ['root', 'admin', 'lead', 'member', 'responsible', 'contributor'],
    // Houdt uit roleNames enkel de rollen over die een gebruiker met rol ownRoleName mag zien.
    // Rollen buiten de hiërarchie (bv. connector) vallen niet onder deze regel en blijven staan.
    filterVisibleRoleNames(roleNames, ownRoleName) {
        const ownIndex = this.roleHierarchy.indexOf(ownRoleName);
        return roleNames.filter(roleName => {
            const index = this.roleHierarchy.indexOf(roleName);
            return index == -1 || (ownIndex != -1 && index >= ownIndex);
        });
    },
    // Rollen die ook hun eigen rol mogen toekennen en beheren (#1568): een beheerder maakt andere
    // beheerders aan en past ze aan. Root staat hoger in de hiërarchie en blijft dus buiten bereik.
    sameRoleManagers: ['admin'],
    // Houdt uit roleNames enkel de rollen over die een gebruiker met rol ownRoleName mag aanmaken of
    // aanpassen: strikt lager dan de eigen rol, of gelijk voor sameRoleManagers. Rollen buiten de
    // hiërarchie blijven ook hier staan.
    filterManageableRoleNames(roleNames, ownRoleName) {
        const ownIndex = this.roleHierarchy.indexOf(ownRoleName);
        const sameRoleAllowed = this.sameRoleManagers.includes(ownRoleName);
        return roleNames.filter(roleName => {
            const index = this.roleHierarchy.indexOf(roleName);
            return index == -1 || (ownIndex != -1 && (index > ownIndex || (sameRoleAllowed && index == ownIndex)));
        });
    },
    // Rolgroepen waartussen een bestaande gebruiker mag wisselen (contact <-> medewerker).
    switchableRoleGroups: ['collaborators', 'contacts'],
    roleGroupLabels: {
        collaborators: 'Medewerkers',
        contacts: 'Contacten'
    },
    keycloakRoles: [
        {
            value: 'admin',
            text: 'Beheerder'
        },
        {
            value: 'lead',
            text: 'Teamleider'
        },
        {
            value: 'member',
            text: 'Teamlid'
        },
        {
            value: 'responsible',
            text: 'Verantwoordelijke'
        },
        {
            value: 'contributor',
            text: 'Gast'
        },
        {
            value: 'informant',
            text: 'Informant'
        },
    ],
    eventTableHeaders: [
        { text: 'Einde', value: 'duration', groupable: false, sortable: true },
        { text: 'Meetwaarde', value: 'measurementType.name', groupable: false, sortable: false },
        { text: 'Waarde', value: 'value', groupable: false },
        { text: 'Bericht', value: 'message', groupable: false, sortable: false },
        { text: 'Type', value: 'type', groupable: false },
        { text: 'Niveau', value: 'severity' },
        { text: 'Status', value: 'status' },
        { text: 'Logs', value: 'logs', groupable: false, sortable: false },
        { text: 'Databron', value: 'owner.name', sortable: false },
        { text: 'Onderdeel', value: 'facility', sortable: false },
        { text: 'Gebruiker', value: 'responsibleUser.name', sortable: false },
        { text: 'Commentaar', value: 'comments', groupable: false, sortable: false },
        //{ text: 'Afbeeldingen', value: 'images', groupable: false, sortable: false },
        { text: 'Asset', value: 'product.name', sortable: false },
        { text: 'Project', value: 'project.name', sortable: false },
        { text: 'Bedrijf', value: 'company.name', sortable: false },

        //{ text: 'Categorie', value: 'category' },
        //{ text: 'Gebruikte materialen', value: 'usedProducts', groupable: false, sortable: false },
    ],
    permissions: {
        'edit-dashboard': ['eod', 'collaborators'],
        'edit-root-settings': ['eod'],
        'export-backup': ['eod'],
        'import-items': ['eod', 'collaborators'],
        'export-items': ['eod', 'collaborators'],
    },
    listItemTypes: [
        { id: 'RANGE', type: 'range', fields: ['low', 'high', 'stepSize'] },
        { id: 'RANGE_TO_TEXT', type: 'range', fields: ['name', 'low', 'high', 'stepSize'] },
        { id: 'VALUE_TO_TEXT', type: 'value', fields: ['name', 'threshold', 'color'] },
        { id: 'USER', type: 'user', fields: ['user'] },
        { id: 'COMPANY', type: 'object', endpoint: 'companies', fields: ['object'] },
        { id: 'PROJECT', type: 'object', endpoint: 'projects', fields: ['object'] },
        { id: 'SERVICE', type: 'object', endpoint: 'services', fields: ['object'] }
    ],
    getListItemTypeById(id) {
        for (let i = 0; i < this.listItemTypes.length; i++) {
            const listItemType = this.listItemTypes[i];
            if (listItemType.id == id) {
                return listItemType;
            }
        }

        return null;
    },
    fieldTypes: [
        { value: 'number', text: 'Getal', info: 'Een numerieke waarde' },
        { value: 'textarea', text: 'Tekst', info: 'Tekstveld' },
        { value: 'yesno', text: 'Ja/Nee', info: 'Keuze tussen Ja (1) en Nee (0)' },
        { value: 'scale', text: 'Keuzelijst', info: 'Een bestaande of nieuwe lijst waar je eenvoudig opties kan toevoegen of verwijderen en waarvan 1 item kan gekozen worden' },
        { value: 'table', text: 'Tabel', info: 'Een tabel met zelf gekozen kolommen waaraan rijen kunnen toegevoegd worden' }
    ],
    objectTypes: {
        project: 'projects',
        task: 'tasks',
        service: 'services',
        response: 'responses',
        company: 'companies',
        tasktype: 'taskTypes',
        product: 'products',
        producttype: 'productTypes',
        storageobject: 'storageObjects',
        alarm: 'alarms',
        form: 'forms',
        formmeasurementtype: 'formMeasurementTypes',
    },
    modules: {
        companies: {
            key: 'companyId',
            item: 'company',
            endpoint: 'companies',
            icon: 'mdi-office-building-outline',
            children: ['projects', 'tasks'],
            route: 'company',
            get model() { return require('../models/company').default; }
        },
        projects: {
            key: 'projectId',
            item: 'project',
            endpoint: 'projects',
            icon: 'mdi-folder-open-outline',
            route: 'project',
            parents: {
                companies: 'company'
            },
            children: ['products'],
            get model() { return require('../models/project').default; },
        },
        tasks: {
            key: 'taskId',
            item: 'task',
            endpoint: 'jobs',
            icon: 'mdi-clipboard-outline',
            parents: {
                projects: 'project',
                taskTypes: 'taskType'
            },
            get model() { return require('../models/job').default; },
            hasTimeSelector: true,
        },
        workflows: {
            key: 'taskId',
            item: 'task',
            endpoint: 'tasks',
            icon: 'mdi-clipboard-outline',
            route: 'tasks.overview',
            parents: {
                projects: 'project',
                taskTypes: 'taskType'
            },
            get model() { return require('../models/workflow').default; },
            hasTimeSelector: true,
        },
        taskTypes: {
            key: 'taskTypeId',
            item: 'taskType',
            endpoint: 'taskTypes',
            icon: 'mdi-clipboard-outline',
            get model() { return require('../models/taskType').default; }
        },
        services: {
            key: 'serviceId',
            item: 'service',
            endpoint: 'services',
            icon: 'mdi-file-sign',
            get model() { return require('../models/service').default; }
        },
        measurementTypes: {
            key: 'measurementTypeId',
            item: 'measurementType',
            endpoint: 'measurementTypes',
            icon: 'mdi-waveform',
            get model() { return require('../models/measurementType').default; }
        },
        users: {
            key: 'userId',
            item: 'user',
            endpoint: 'searchUsers',
            icon: 'mdi-account-group-outline',
            get model() { return require('../models/user').default; }
        },
        contacts: {
            key: 'userId',
            item: 'user',
            endpoint: 'searchUsers',
            icon: 'mdi-account-group-outline',
            get model() { return require('../models/contact').default; }
        },
        dataConnectors: {
            key: 'userId',
            item: 'user',
            endpoint: 'searchUsers',
            icon: 'mdi-account-group-outline',
            get model() { return require('../models/dataConnector').default; }
        },
        products: {
            key: 'productId',
            item: 'product',
            icon: 'mdi-cube-outline',
            endpoint: 'products',
            treeview: true,
            customFields: {
                endpoint: 'products',
                extraFields: ['productTypes']
            },
            get model() { return require('../models/product').default; },
            canImport: true
        },
        articles: {
            key: 'articleId',
            item: 'article',
            icon: 'mdi-package-variant',
            endpoint: 'articles',
            treeview: true,
            customFields: {
                endpoint: 'articles',
                extraFields: ['articleTypes']
            },
            get model() { return require('../models/article').default; }
        },
        tools: {
            key: 'toolId',
            item: 'tool',
            icon: 'mdi-tools',
            endpoint: 'tools',
            treeview: true,
            get model() { return require('../models/tool').default; }
        },
        productTypes: {
            key: 'productTypeId',
            item: 'productType',
            endpoint: 'productTypes',
            icon: 'mdi-package-variant',
            get model() { return require('../models/productType').default; }
        }
    },
    relativeTimeRanges: [
        {
            type: 'years',
            value: -1,
            colsize: 10,
            text: 'Voorbije jaar',
            singleDate: false,
            closest: 'day'
        },
        {
            type: 'months',
            value: -1,
            colsize: 10,
            text: 'Voorbije maand',
            singleDate: false,
            closest: 'day'
        },
        {
            type: 'weeks',
            value: -1,
            colsize: 20,
            text: 'Voorbije week',
            singleDate: false,
            closest: 'day'
        },
        {
            type: 'hours',
            value: -24,
            colsize: 40,
            text: 'Voorbije 24u',
            singleDate: true
        },
        {
            type: 'days',
            value: 0,
            colsize: 40,
            text: 'Vandaag',
            singleDate: true,
            closest: 'day'
        },
        {
            type: 'days',
            value: 1,
            colsize: 40,
            text: 'Morgen',
            singleDate: true,
            absolute: true,
        },
        {
            type: 'weeks',
            value: 0,
            colsize: 20,
            text: 'Deze week',
            singleDate: false,
            closest: 'week'
        },
        {
            type: 'months',
            value: 0,
            colsize: 10,
            text: 'Deze maand',
            singleDate: false,
            closest: 'month'
        },
        {
            type: 'years',
            value: 0,
            colsize: 10,
            text: 'Dit jaar',
            singleDate: false,
            closest: 'year'
        },
    ],
    routeColors: [
        {
            hex: '#021F59'
        },
        {
            hex: '#1CA63F'
        },
        {
            hex: '#F27141'
        },
        {
            hex: '#4EBFD9'
        },
        {
            hex: '#B357A5'
        },
        {
            hex: '#7D522D'
        },
        {
            hex: '#03588C'
        },
        {
            hex: '#F25260'
        },
        {
            hex: '#B357A5'
        }
    ],
    frequencies: [
        {
            value: 'FREQ=DAILY;INTERVAL=1',
            text: 'Dagelijks'
        },
        {
            value: 'FREQ=WEEKLY;INTERVAL=1',
            text: 'Wekelijks'
        },
        {
            value: 'FREQ=MONTHLY;INTERVAL=1',
            text: 'Maandelijks'
        },
        {
            value: 'FREQ=YEARLY;INTERVAL=1',
            text: 'Jaarlijks'
        },
    ],
    resolveFrequency(value) {
        for (let i = 0; i < this.frequencies.length; i++) {
            const frequency = this.frequencies[i];
            if (value == frequency.value) {
                return frequency;
            }
        }

        return null;
    },
    getListItemTypeById(id) {
        for (let i = 0; i < this.listItemTypes.length; i++) {
            const listItemType = this.listItemTypes[i];
            if (listItemType.id == id) {
                return listItemType;
            }
        }

        return null;
    },
    workflowStatusCodes: [
        {
            icon: 'mdi-flag-variant-outline',
            color: '#2683ab',
            textColor: 'white',
            value: 'start',
            text: 'Start',
            workflow_enabled: false
        },
        {
            icon: 'mdi-clipboard-account-outline',
            color: '#25dbc6',
            textColor: 'white',
            value: 'dispatch',
            text: 'Dispatch',
            workflow_enabled: false
        },
        {
            icon: 'mdi-clipboard-edit-outline',
            color: '#f55bbc',
            textColor: 'white',
            value: 'form',
            text: 'Formulier',
            workflow_enabled: true
        },
        {
            icon: 'mdi-clipboard-play-outline',
            color: '#3381ff',
            textColor: 'white',
            value: 'automation',
            text: 'Automatisering',
            workflow_enabled: true
        },
        {
            icon: 'mdi-clipboard-clock-outline',
            color: '#031859',
            textColor: 'white',
            value: 'plan',
            text: 'Inplannen',
            workflow_enabled: false
        },
        {
            icon: 'mdi-clipboard-search-outline',
            color: '#FFD500',
            textColor: 'white',
            value: 'verify',
            text: 'Goedkeuren',
            workflow_enabled: false
        },
        {
            icon: 'mdi-clipboard-check-outline',
            color: '#09bc8a',
            textColor: 'white',
            value: 'end',
            text: 'Afgewerkt',
            workflow_enabled: false
        }
    ],
    stepTypes: [
        {
            value: 'START',
            text: 'Start',
        },
        {
            value: 'FORM',
            text: 'Formulier',
        },
        {
            value: 'VERIFY',
            text: 'Goedkeuren',
        },
        {
            value: 'END',
            text: 'Afgewerkt',
        }
    ],
    statusCodes: [
        {
            icon: 'mdi-flag-variant-outline',
            color: '#f1f3f5',
            textColor: 'dark',
            value: 'start',
            text: 'Nieuw',
            task_enabled: false,
            workflow_enabled: false,
        },
        {
            icon: 'mdi-calendar-remove',
            color: '#ff922b',
            textColor: 'white',
            value: 'backlog',
            text: 'Planning',
            task_enabled: false,
            workflow_enabled: false,
        },
        {
            icon: 'mdi-account-check',
            color: '#748ffc',
            textColor: 'white',
            value: 'to_be_assigned',
            text: 'Toewijzing',
            task_enabled: false,
            workflow_enabled: false,
        },

        {
            icon: 'mdi-wrench-check',
            color: '#4dabf7',
            textColor: 'white',
            value: 'in_preparation',
            text: 'Voorbereiding',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },
        {
            icon: 'mdi-tune-variant',
            color: '#339af0',
            textColor: 'white',
            value: 'configuration_required',
            text: 'Configuratie',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },

        {
            icon: 'mdi-robot-outline',
            color: '#9775fa',
            textColor: 'white',
            value: 'automation_required',
            text: 'Automatisering instellen',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },
        {
            icon: 'mdi-cog-sync-outline',
            color: '#845ef7',
            textColor: 'white',
            value: 'automatic_processing',
            text: 'Automatische verwerking',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },

        {
            icon: 'mdi-calendar',
            color: '#74c0fc',
            textColor: 'dark',
            value: 'to_do',
            text: 'Ingepland',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },
        {
            icon: 'mdi-run',
            color: '#364fc7',
            textColor: 'white',
            value: 'in_progress',
            text: 'Uitvoeren',
            calendar_enabled: true,
            workflow_enabled: true,
            task_enabled: true,
            job_enabled: true,
        },

        {
            icon: 'mdi-magnify',
            color: '#ffd43b',
            textColor: 'dark',
            value: 'to_be_reviewed',
            text: 'Beoordeling',
            calendar_enabled: true,
            workflow_enabled: false,
            task_enabled: false,
            job_enabled: true,
        },
        {
            icon: 'mdi-eye',
            color: '#ffa94d',
            textColor: 'dark',
            value: 'to_be_verified',
            text: 'Goedkeuring',
            task_enabled: false,
            workflow_enabled: false,
        },

        {
            icon: 'mdi-check',
            color: '#20c997',
            textColor: 'white',
            value: 'done',
            text: 'Afgerond',
            calendar_enabled: true,
            task_enabled: false,
            workflow_enabled: false,
        },
        {
            icon: 'mdi-check-decagram-outline',
            color: '#339af0',
            textColor: 'white',
            value: 'confirmed',
            text: 'Bevestigd',
            task_enabled: false,
            workflow_enabled: false,
        },

        {
            icon: 'mdi-cancel',
            color: '#ff922b',
            textColor: 'white',
            value: 'on_hold',
            text: 'Geblokkeerd',
            task_enabled: true,
            workflow_enabled: true,
            job_enabled: true,
        },
        {
            icon: 'mdi-close',
            color: '#fa5252',
            textColor: 'white',
            value: 'cancelled',
            text: 'Geannuleerd',
            task_enabled: false,
            workflow_enabled: false,
        },
        {
            icon: 'mdi-close-octagon-outline',
            color: '#fa9b52',
            textColor: 'white',
            value: 'rejected',
            text: 'Afgewezen',
            task_enabled: false,
            workflow_enabled: false,
        },
        {
            icon: 'mdi-close-octagon-outline',
            color: '#adb5bd',
            textColor: 'dark',
            value: 'no_action',
            text: 'Geen actie',
            task_enabled: false,
            workflow_enabled: false,
        }
    ],
    influxInterval: [{
        value: '1s',
        text: 'Seconde'
    },
    {
        value: '1m',
        text: 'Minuut'
    },
    {
        value: '5m',
        text: '5 minuten'
    },
    {
        value: '1h',
        text: 'Uur'
    },
    {
        value: '8h',
        text: '8 uur'
    },
    {
        value: '1mo',
        text: 'Maand'
    },
    {
        value: '1d',
        text: 'Dag'
    }
    ],
    periodicity: [
        {
            value: null,
            text: 'Geen'
        },
        {
            value: 'RRULE:FREQ=DAILY;INTERVAL=1;',
            text: 'Dagelijks'
        },
        {
            value: 'RRULE:FREQ=DAILY;INTERVAL=1;BYDAY=MO,TU,WE,TH,FR;',
            text: 'Werkdagen'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=1;',
            text: 'Wekelijks'
        },
        {
            value: 'RRULE:FREQ=DAILY;INTERVAL=1;BYDAY=SA,SU;',
            text: 'Weekends'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=2;',
            text: 'Tweewekelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=3;',
            text: 'Driewekelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=4;',
            text: 'Maandelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=6;',
            text: 'Zeswekelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=8;',
            text: 'Tweemaandelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=13;',
            text: 'Driemaandelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=17;',
            text: 'Viermaandelijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=26;',
            text: 'Halfjaarlijks'
        },
        {
            value: 'RRULE:FREQ=WEEKLY;INTERVAL=52;',
            text: 'Jaarlijks'
        },
    ],
    getStatusCode(code_id) {
        const codes = this.statusCodes;
        for (let i = 0; i < codes.length; i++) {
            if (codes[i].value == code_id) {
                return codes[i];
            }
        }
        return null;
    },
    getWorkflowStatusCode(code_id) {
        const codes = this.workflowStatusCodes;
        for (let i = 0; i < codes.length; i++) {
            if (codes[i].value == code_id) {
                return codes[i];
            }
        }
        return null;
    }
}